export default "__VITE_ASSET__DEQdDVEk__"